<script setup lang="ts">
import type { IconColor, IconSize } from '@/types';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  size?: IconSize
  color?: IconColor
}>(), {
  size: 'md',
  color: 'current'
});

const iconSizeClasses = computed(() => {
  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10'
  };
  
  return sizes[props.size];
});

const colorClasses = {
  current: 'text-current',
  primary: 'text-primary',
  secondary: 'text-secondary-500',
  white: 'text-white',
  error: 'text-error',
  success: 'text-success',
  warning: 'text-warning',
};

const iconColorClass = computed(() => {
  if (props.color === 'current') return 'text-current';
  
  return colorClasses[props.color] || 'text-current';
});

const combinedClasses = computed(() => [
  iconSizeClasses.value,
  iconColorClass.value
]);
</script>

<template>
  <span class="flex items-center justify-center" :class="combinedClasses">
    <!-- Dynamic icon loading through slot -->
    <slot></slot>
  </span>
</template> 